import { Card } from '@apovisio/ui';
import { Link } from 'react-router';
import { BrandMark } from '../app/BrandMark';

export function HomePage() {
  return (
    <main className="app-centered">
      <Card padding="lg" className="app-narrow" as="div">
        <BrandMark />
        <div className="av-stack av-stack--sm">
          <h1 className="app-title">Visioconférence Apogée Consult</h1>
          <p className="av-text-secondary">
            Vous avez reçu une invitation ? Ouvrez directement le lien personnel qui vous a été
            transmis.
          </p>
        </div>
        <Link className="av-button av-button--secondary" to="/admin">
          Espace Apogée
        </Link>
      </Card>
    </main>
  );
}
